import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MaterialModule } from "../../../core/shared/material.module";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-expansion-panel-view",
  standalone: true,
  imports: [MaterialModule, CommonModule,...SharedComponents],
  templateUrl: "./expansion-panel-view.component.html",
  styleUrl: "./expansion-panel-view.component.scss",
})
export class ExpansionPanelViewComponent {
  @Input() data: any[] = [];

  objectKeys = Object.keys;

  meta = [
    {
      display_name: "Component",
      key: "component",
      type: "string",
    },
    {
      display_name: "Test Case",
      key: "test_case",
      type: "string",
    },
    {
      display_name: "Reason",
      key: "reason",
      type: "list",
    },
    {
      display_name: 'Representation',
      key: 'representation',
      type: 'table'
    }
  ];

  getMeta(key: string) {
    return this.meta.find((item) => item.key === key);
  }

  printData(data: any) {
    console.log('priont Data', data);
  }

  getHeaderClass(name: string): string {
    switch (name) {
      case 'Stable':
        return 'header-section-stable';
      case 'Critical':
        return 'header-section-critical';
      case 'Flaky':
        return 'header-section-flaky';
      default:
        return 'header-default';
    }
  }
  
}
